<template>
  <div> 
    <div class="home" v-if="pcShow">
      <headerTitle indexInit="0" />
      <carouselPics :pics="pics" carouselIndex="0" />
      <div class="block_div"></div>
      <titleBlock textChinese="服务项目" flagIndex="1" textEnglish="PROJECT  CLASSIFICATION" />
      <div class="block_div"></div>
      <serviceBlockBuss />
      <div class="block_div"></div>
      <div class="block_div"></div>
      <titleBlock textChinese="案例展示" flagIndex="1" textEnglish="CASE SHOW" />
      <div class="block_div"></div>
      <videoBlockSelectOdd :videoArray="videoArray" @selectPics="selectPics" flagIndex="1" />
      <!-- <videoBlock :videoArray="videoArray" @selectPics="selectPics" flagIndex="1"/> -->
      <div class="block_div"></div>
      <titleBlock textChinese="我们的优势" textEnglish="OURS  ADVANCED" />
      <div class="block_div"></div>
      <serviceAdvanced />
      <div class="block_div"></div>
      <serviceProgress />
      <div class="block_div"></div>
      <titleBlock textChinese="服务过的客户" textEnglish="COOPERATION PARTNERS" />
      <div class="block_div"></div>
      <serviceClient />
      <div class="block_div"></div>
      <footerBlock />
      <videoEachBlock @closeVideoFn="closeVideoFn" :videoUrl="videoUrl" v-if="videoFlag" />

      <!-- <el-carousel class="wrap_pics">
      <el-carousel-item v-for="item in pics" :key="item">
        <h3 class="small">{{ item }}</h3>
        <img class="pics_each" :src="item.url"/>
      </el-carousel-item>
      </el-carousel>-->
      <!-- <img alt="Vue logo" src="../assets/logo.png">
      <HelloWorld msg="Welcome to Your Vue.js App"/>-->
    </div>
    <div v-if="!pcShow" >
      <mobileHeader indexInit="0" />
      <mobileCarousel :pics="images" carouselIndex="0" />
      <div class="wrap_mobile_home">
      <mobileDivBlock />
      <mobileTitleBlock textChinese="服务项目" flagIndex="1" textEnglish="PROJECT  CLASSIFICATION" />
      <mobileDivBlock />
      <mobileServiceBlockBuss />
      <mobileDivBlock />
      <mobileTitleBlock textChinese="案例展示" flagIndex="1" textEnglish="CASE SHOW" />

     <mobileDivBlock />
      <mobilevideoBlockSelectOdd :videoArray="videoArray" @selectPics="selectPics" flagIndex="1" />
      <mobileDivBlock />
      <mobileTitleBlock textChinese="我们的优势" textEnglish="OURS  ADVANCED" />
      <mobileserviceAdvanced />
<mobileDivBlock />
<mobileprogress /> 
      <mobileDivBlock />

      <mobileTitleBlock textChinese="服务过的客户" textEnglish="COOPERATION PARTNERS" />
      <mobileDivBlock />
<mobileserviceClient />
<mobileDivBlock />
<mobilefooterBlock />
<videoEachBlock @closeVideoFn="closeVideoFn" :videoUrl="videoUrl" v-if="videoFlag" />

    </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import carouselPics from "@/components/carouselPics.vue";
import headerTitle from "@/components/headerTitle.vue";
import mobileHeader from "@/components/mobileHeader.vue";
import mobileCarousel from "@/components/mobileCarousel.vue";
import titleBlock from "@/components/titleBlock.vue";
import mobileTitleBlock from "@/components/mobileTitleBlock.vue";
import serviceBlockBuss from "@/components/serviceBlockBuss.vue";
import mobileServiceBlockBuss from "@/components/mobileServiceBlockBuss.vue";
 

import videoBlock from "@/components/videoBlock.vue";
import serviceProgress from "@/components/serviceProgress.vue";
import serviceClient from "@/components/serviceClient.vue";
import mobileserviceClient from "@/components/mobileserviceClient.vue";


import footerBlock from "@/components/footerBlock.vue";
import mobilefooterBlock from "@/components/mobilefooterBlock.vue";

import serviceAdvanced from "@/components/serviceAdvanced.vue";
import mobileserviceAdvanced from "@/components/mobileserviceAdvanced.vue";
import videoEachBlock from "@/components/videoEachBlock.vue";
import videoBlockSelectOdd from "@/components/videoBlockSelectOdd.vue";
import mobilevideoBlockSelectOdd from "@/components/mobilevideoBlockSelectOdd.vue";
import mobileDivBlock from "@/components/mobileDivBlock.vue";
import mobileprogress from "@/components/mobileprogress.vue";

export default {
  name: "Home",
  data() {
    return {
      videoUrl: {},
      // videoUrl:{videoUrl:require('@/assets/video/bose耳机达人系列广告.mp4')},
      videoFlag: false,
      pics: [
        // {url:require('@/assets/imgs/banner101.jpeg'),style:'text-align:center',text:'<span style="font-size:54px;color:#fff">业内靠谱的</span><span style="font-size:62px;color:#e91d62">影像服务商</span>'},
        {
          url: require("@/assets/imgs/banner104.jpeg"),
          linerow: 3,
          style: "text-align:right;",
          text:
            '<span style="font-size:54px;color:#fff">业内靠谱的</span><span style="font-size:62px;color:#e91d62;padding-right:100px">影像服务商</span>'
        },
        {
          url: require("@/assets/imgs/banner102.jpeg"),
          linerow: 2,
          style: "margin-left:200px;text-align:left",
          text:
            '<span style="font-size:54px;color:#fff">星沐互娱成立于2019年</span><br /><span style="font-size:54px;color:#fff">是一家具有</span><span style="font-size:62px;color:#e91d62">互联网基因和理念</span><span style="font-size:54px;color:#fff">的传媒企业</span>'
        },
        {
          url: require("@/assets/imgs/banner103.jpeg"),
          linerow: 4,
          style: "margin-left:-100px;text-align:right",
          text:
            '<span style="font-size:62px;color:#e91d62">想办法<br /><span style="font-size:54px;color:#fff">我们竭尽全力</span><br /><span style="font-size:54px;color:#fff">为客户提供可行的解决方案</span>'
        }
      ],
      videoArray: [
        {
          url: require("@/assets/video/video503.jpg"),
          text: "清华博士带你走进迷你实验室",
          videoUrl: require("@/assets/video/video503.mp4")
        },
        {
          url: require("@/assets/video/video02.jpg"),
          text: "郎佳子彧的手工课",
          videoUrl: require("@/assets/video/video02.mp4")
        },
        {
          url: require("@/assets/video/video03.jpg"),
          text: "福彩手工艺大赛系列专题片",
          videoUrl: require("@/assets/video/video03.mp4")
        },
        {
          url: require("@/assets/video/video04.jpg"),
          text: "航空航天知识科普",
          videoUrl: require("@/assets/video/video04.mp4")
        },
        {
          url: require("@/assets/video/video05.jpg"),
          text: "森林里的诗词课",
          videoUrl: require("@/assets/video/video05.mp4")
        },
        {
          url: require("@/assets/video/video06.jpg"),
          text: "微软mv《Open Windows》",
          videoUrl: require("@/assets/video/video06.mp4")
        },
        {
          url: require("@/assets/video/video07.jpg"),
          text: "喜马拉雅vs腾讯视频双重会员TVC",
          videoUrl: require("@/assets/video/video07.mp4")
        },
        {
          url: require("@/assets/video/video08.jpg"),
          text: "bose耳机达人系列广告",
          videoUrl: require("@/assets/video/video08.mp4")
        }
      ],
      pcShow: true,
      images: [
        // {url:require('@/assets/imgs/banner101.jpeg'),style:'text-align:center',text:'<span style="font-size:54px;color:#fff">业内靠谱的</span><span style="font-size:62px;color:#e91d62">影像服务商</span>'},
        {
          url: require("@/assets/imgs/banner104.jpeg"),
          linerow: 3,
          style: "text-align:right;",
          text:
            '<span style="font-size:16px;color:#fff">业内靠谱的</span><span style="font-size:16px;color:#e91d62;padding-right:50px">影像服务商</span>'
        },
        {
          url: require("@/assets/imgs/banner102.jpeg"),
          linerow: 2,
          style: "text-align:right",
          text:
            '<span style="font-size:16px;color:#fff;padding-right:50px">星沐互娱成立于2019年</span><br /><span style="font-size:16px;color:#fff">是一家具有</span><span style="font-size:16px;color:#e91d62">互联网基因和理念</span><span style="font-size:16px;color:#fff;padding-right:50px">的传媒企业</span>'
        },
        {
          url: require("@/assets/imgs/banner103.jpeg"),
          linerow: 4,
          style: "margin-left:-50px;text-align:right",
          text:
            '<span style="font-size:16px;color:#e91d62">想办法<br /><span style="font-size:16px;color:#fff">我们竭尽全力</span><br /><span style="font-size:16px;color:#fff">为客户提供可行的解决方案</span>'
        }
      ],
      
    };
  },
  components: {
    carouselPics,
    headerTitle,
    titleBlock,
    serviceBlockBuss,
    videoBlock,
    serviceProgress,
    serviceClient,
    footerBlock,
    serviceAdvanced,
    videoEachBlock,
    videoBlockSelectOdd,
    mobileHeader,
    mobileCarousel,
    mobileTitleBlock,
    mobileDivBlock,
    mobileServiceBlockBuss,
    mobilevideoBlockSelectOdd,
    mobileserviceAdvanced,
    mobileprogress,
    mobileserviceClient,
    mobilefooterBlock,

  },
  methods: {
    widthChange() {
      console.log(123333);
      let clientWidthW = document.body.clientWidth;
      console.log(this.pcShow, "999000this.pcShow");
      console.log(clientWidthW, "9900");
      if (clientWidthW <= 768) {
        this.pcShow = false;
      } else {
        this.pcShow = true;
      }
    },
    closeVideoFn() {
      this.videoFlag = false;
    },
    selectPics(item) {
      // this.videoFlag = true
      // this.videoUrl.videoUrl = this.videoArray[index][inx].videoUrl
      // console.log(this.videoUrl,'this.videoUrl')
      this.videoFlag = true;
      this.videoUrl.videoUrl = item.videoUrl;
      // this.videoUrl.videoUrl = this.videoArray[index][inx].videoUrl
      console.log(this.videoUrl, "this.videoUrl");
    }
  },
  mounted() {
    // this.videoUrl.videoUrl = this.videoArray[0][0].videoUrl
    this.widthChange();
    window.addEventListener("resize", this.widthChange);

    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live: true
      }).init();
    });
  }
};
</script>
<style lang="less">
.wrap_mobile_home{
  div{
    overflow: hidden;
  }
}

</style>
